// extracted by mini-css-extract-plugin
module.exports = {"descriptionList":"DescriptionList-descriptionList-2v6H6"};